export default __webpack_public_path__ + "static/media/research.4f3c1a46.jpg";